import React from 'react';
import PropTypes from 'prop-types';
import {
  CardNumberElement, CardExpiryElement, CardCvcElement, ElementsConsumer,
} from '@stripe/react-stripe-js';
import {
  Button, FormFeedback, FormGroup, Label, Row, Col,
} from 'reactstrap';
import { Required } from '../../helpers/formHelper';

class AddNewCardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      submitting: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitting: true });
    const cardElement = this.props.elements.getElement(CardNumberElement);
    this.props.stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    }).then((result) => {
      if (result.error) {
        this.setState({
          error: result.error.message,
          submitting: false,
        });
        return;
      }
      const paymentMethodId = result.paymentMethod.id;
      if (!this.props.client_secret) {
        this.props.submitCreditForm(paymentMethodId);
        return;
      }
      // payment_intent.client_secretがある場合は、決済を行う
      this.props.stripe.confirmCardPayment(this.props.client_secret, {
        payment_method: paymentMethodId,
      }).then((confirmResult) => {
        if (confirmResult.error) {
          this.setState({
            error: confirmResult.error.message,
            submitting: false,
          });
          return;
        }
        this.props.submitCreditForm(paymentMethodId);
      });
    });
  };

  handleOnChange = (e) => {
    this.setState({
      error: e.error ? e.error.message : null,
    });
  };

  render() {
    const style = {
      base: {
        color: '#32325D',
        fontWeight: 500,
        fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
        fontSize: '16px',
        fontSmoothing: 'antialiased',

        '::placeholder': {
          color: '#CFD7DF',
        },
        ':-webkit-autofill': {
          color: '#e39f48',
        },
      },
      invalid: {
        color: '#E25950',

        '::placeholder': {
          color: '#FFCCA5',
        },
      },
    };
    const { error, submitting } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <FormGroup>
          <Label>カード番号</Label>
          <Required />
          <CardNumberElement style={style} className="form-control" onChange={this.handleOnChange} />
        </FormGroup>
        <Row>
          <Col style={{ paddingRight: '5px' }}>
            <Label>有効期限(月 /  年)</Label>
            <Required />
            <CardExpiryElement style={style} className="form-control" onChange={this.handleOnChange} />
          </Col>
          <Col style={{ paddingLeft: '5px' }}>
            <Label>セキュリティコード</Label>
            <Required />
            <CardCvcElement style={style} className="form-control" onChange={this.handleOnChange} />
          </Col>
        </Row>
        {error && (<FormFeedback style={{ display: 'block' }}>{error}</FormFeedback>)}
        <Button
          className="submit"
          type="submit"
          disabled={submitting}
          color="danger"
          size="lg"
        >
          確定する
        </Button>
      </form>
    );
  }
}

AddNewCardForm.defaultProps = {
  client_secret: null,
  stripe: null,
  elements: null,
};

AddNewCardForm.propTypes = {
  elements: PropTypes.shape({
    getElement: PropTypes.func.isRequired,
  }),
  stripe: PropTypes.shape({
    confirmCardPayment: PropTypes.func.isRequired,
    createPaymentMethod: PropTypes.func.isRequired,
  }),
  client_secret: PropTypes.string,
  submitCreditForm: PropTypes.func.isRequired,
};
const InjectedAddNewCardForm = (props) => (
  <ElementsConsumer>
    {({ stripe, elements }) => <AddNewCardForm stripe={stripe} elements={elements} {...props} />}
  </ElementsConsumer>
);
export default InjectedAddNewCardForm;
